/* PARANOIA ORIGINS - light/dark mode, size guide, sticky add-to-cart */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * 1. Light / dark mode
   * ------------------------------------------------------------------ */

  var STORAGE_KEY = 'po-theme';
  var root = document.documentElement;

  function stored() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function persist(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* private mode - the choice just will not survive the session */
    }
  }

  function currentMode() {
    return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function applyMode(mode) {
    root.setAttribute('data-theme', mode === 'dark' ? 'dark' : 'light');
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', mode === 'dark' ? '#17181b' : '#ffffff');
    document.querySelectorAll('.po-mode-toggle').forEach(function (button) {
      button.setAttribute('aria-pressed', String(mode === 'dark'));
      button.setAttribute(
        'aria-label',
        mode === 'dark' ? button.dataset.labelLight || 'Switch to light mode'
                        : button.dataset.labelDark || 'Switch to dark mode'
      );
    });
  }

  function toggleMode() {
    var next = currentMode() === 'dark' ? 'light' : 'dark';
    persist(next);
    applyMode(next);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.po-mode-toggle');
    if (!button) return;
    event.preventDefault();
    toggleMode();
  });

  // Follow the OS only while the visitor has not made an explicit choice.
  if (window.matchMedia) {
    var query = window.matchMedia('(prefers-color-scheme: dark)');
    var onSystemChange = function (event) {
      if (stored()) return;
      if (root.dataset.poDefaultMode !== 'system') return;
      applyMode(event.matches ? 'dark' : 'light');
    };
    if (query.addEventListener) query.addEventListener('change', onSystemChange);
    else if (query.addListener) query.addListener(onSystemChange);
  }

  // Keep other open tabs in sync.
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY && event.newValue) applyMode(event.newValue);
  });

  document.addEventListener('DOMContentLoaded', function () {
    applyMode(currentMode());
  });

  /* ------------------------------------------------------------------ *
   * 2. Size guide modal
   * ------------------------------------------------------------------ */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastFocused = null;

  function openModal(modal, opener) {
    // Prefer the element that opened the dialog: a pointer click does not move
    // focus, so document.activeElement is usually still <body> at this point.
    lastFocused = opener || document.activeElement;
    modal.classList.add('po-sg-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // let the browser paint the display change before animating opacity
    window.requestAnimationFrame(function () {
      modal.classList.add('po-sg-visible');
    });
    var focusTarget = modal.querySelector('.po-sg-close');
    if (focusTarget) focusTarget.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('po-sg-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      modal.classList.remove('po-sg-open');
    }, 240);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }

  function convert(modal, unit) {
    modal.querySelectorAll('[data-cm]').forEach(function (cell) {
      var raw = cell.getAttribute('data-cm');
      if (unit === 'cm') {
        cell.textContent = raw;
        return;
      }
      // Convert every number found, keeping separators like "-" or "/" intact.
      cell.textContent = raw.replace(/\d+(?:[.,]\d+)?/g, function (match) {
        var value = parseFloat(match.replace(',', '.'));
        if (isNaN(value)) return match;
        return (Math.round((value / 2.54) * 10) / 10).toString();
      });
    });
    modal.querySelectorAll('.po-sg-unit').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
    });
    modal.querySelectorAll('[data-unit-label]').forEach(function (node) {
      node.textContent = unit === 'cm' ? 'cm' : 'in';
    });
  }

  function selectTab(modal, chart) {
    modal.querySelectorAll('.po-sg-tab').forEach(function (tab) {
      var active = tab.dataset.chart === chart;
      tab.setAttribute('aria-selected', String(active));
    });
    modal.querySelectorAll('.po-sg-panel').forEach(function (panel) {
      panel.hidden = panel.dataset.chart !== chart;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var trigger = target.closest('.po-sg-trigger');
    if (trigger) {
      var modal = document.getElementById(trigger.getAttribute('aria-controls'));
      if (modal) {
        event.preventDefault();
        if (trigger.dataset.chart) selectTab(modal, trigger.dataset.chart);
        openModal(modal, trigger);
      }
      return;
    }

    var closer = target.closest('.po-sg-close');
    if (closer) {
      var owner = closer.closest('.po-sg-modal');
      if (owner) closeModal(owner);
      return;
    }

    var tab = target.closest('.po-sg-tab');
    if (tab) {
      selectTab(tab.closest('.po-sg-modal'), tab.dataset.chart);
      return;
    }

    var unit = target.closest('.po-sg-unit');
    if (unit) {
      convert(unit.closest('.po-sg-modal'), unit.dataset.unit);
      return;
    }

    // Click on the backdrop itself closes the dialog.
    if (target.classList && target.classList.contains('po-sg-modal')) {
      closeModal(target);
    }
  });

  document.addEventListener('keydown', function (event) {
    var open = document.querySelector('.po-sg-modal.po-sg-open');
    if (!open) return;

    if (event.key === 'Escape') {
      closeModal(open);
      return;
    }

    if (event.key !== 'Tab') return;

    var items = Array.prototype.filter.call(
      open.querySelectorAll(FOCUSABLE),
      function (node) {
        return node.offsetParent !== null;
      }
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------------------------ *
   * 3. Sticky mobile add-to-cart
   * ------------------------------------------------------------------ */

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.po-sticky-atc');
    if (!bar) return;

    var formId = bar.dataset.formId;
    var realButton = document.querySelector(
      '#' + CSS.escape(formId) + ' [name="add"], product-form button[name="add"]'
    );
    if (!realButton) {
      bar.remove();
      return;
    }

    var barButton = bar.querySelector('.po-sticky-atc__button');

    barButton.addEventListener('click', function () {
      realButton.click();
    });

    // Mirror the real button's label and disabled state (sold out, unavailable).
    var sync = function () {
      barButton.disabled = realButton.disabled;
      var label = realButton.querySelector('span');
      if (label) barButton.textContent = label.textContent.trim();
    };
    sync();
    new MutationObserver(sync).observe(realButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    // Show the bar only once the real button has scrolled out of view.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('po-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -80px 0px' }
      ).observe(realButton);
    } else {
      bar.classList.add('po-visible');
    }
  });
})();
